import React, { useState } from "react";
import { toast } from "sonner";
import { postContact } from "@/lib/api";

export default function FormContacto() {
  const [f, setF] = useState({ nombre: "", email: "", tel: "", msg: "" });
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);
  const ok = f.nombre.trim().length > 1 && f.email.includes("@") && f.msg.trim().length > 5;

  const enviar = async () => {
    if (!ok || loading) return;
    setLoading(true);
    try {
      await postContact({ nombre: f.nombre, email: f.email, telefono: f.tel, mensaje: f.msg });
      setEnviado(true);
    } catch (e) {
      toast.error("No se pudo enviar el mensaje. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  if (enviado) {
    return (
      <div className="cform" data-testid="contact-form">
        <div className="form-ok" data-testid="contact-success">✓ &nbsp;¡Mensaje enviado! Te responderemos en menos de 24 horas.</div>
        <button className="btn btn-ghost btn-sm" style={{ marginTop: 18 }}
          onClick={() => { setEnviado(false); setF({ nombre: "", email: "", tel: "", msg: "" }); }}>
          Enviar otro mensaje
        </button>
      </div>
    );
  }
  return (
    <div className="cform" data-testid="contact-form">
      <div className="field-row">
        <div className="field">
          <label htmlFor="ct-nombre">Nombre</label>
          <input id="ct-nombre" data-testid="contact-nombre" value={f.nombre} onChange={(e) => setF({ ...f, nombre: e.target.value })} placeholder="Tu nombre" />
        </div>
        <div className="field">
          <label htmlFor="ct-tel">Teléfono / WhatsApp</label>
          <input id="ct-tel" data-testid="contact-tel" value={f.tel} onChange={(e) => setF({ ...f, tel: e.target.value })} placeholder="+34 · +52 · +54 …" />
        </div>
      </div>
      <div className="field">
        <label htmlFor="ct-email">Email</label>
        <input id="ct-email" data-testid="contact-email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="tu@email.com" />
      </div>
      <div className="field">
        <label htmlFor="ct-msg">¿En qué podemos ayudarte?</label>
        <textarea id="ct-msg" data-testid="contact-msg" value={f.msg} onChange={(e) => setF({ ...f, msg: e.target.value })} placeholder="Cuéntanos tu duda sobre los cursos, el VIP vitalicio, pagos…" />
      </div>
      <button className="btn btn-gold" data-testid="contact-submit" style={{ width: "100%", justifyContent: "center", opacity: ok ? 1 : 0.45 }} onClick={enviar}>
        {loading ? "Enviando…" : "Enviar mensaje →"}
      </button>
    </div>
  );
}
